import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, type PropsWithChildren } from 'react';
import { useSuperAdminAuthStore } from '@stores/superAdminAuth';
import { FullPageSpinner } from '@components/ui';

export function SuperAdminProtectedRoute({ children }: PropsWithChildren) {
  const { isAuthenticated, hydrated, hydrate } = useSuperAdminAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (!hydrated) hydrate();
  }, [hydrated, hydrate]);

  if (!hydrated) return <FullPageSpinner />;
  if (!isAuthenticated) {
    return <Navigate to="/superadmin-login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
